import api from "./api"

export const getHrDashboard = async (params = {}) =>
  (await api.get("/hr/dashboard", { params })).data
